import NewTable from "components/NewTable";
import useRelatorioReservasTableColumns from "./../../hooks/useRelatorioReservasTableColumns";
import { RelatorioReservasResponse } from "core/features/relatorios/typings/index";
import { FiltroRelatorioReservas } from "core/features/relatorios/typings/index";
import { PaginateResult } from "core/resources/types/shared";

interface TableRelatorioReservasProps {
  data: PaginateResult<RelatorioReservasResponse> | undefined;
  isLoading: boolean;
  onChangeFiltro: (newValues: Partial<FiltroRelatorioReservas>) => void;
}

export default function TableRelatorioReservas({
  data,
  isLoading,
  onChangeFiltro,
}: TableRelatorioReservasProps) {
  const columns = useRelatorioReservasTableColumns();

  return (
    <NewTable
      loading={isLoading}
      columns={columns}
      dataSource={data?.items ?? []}
      customPagination={{
        currentPage: data?.meta?.currentPage ?? 1,
        totalItems: data?.meta?.totalItems ?? data?.items?.length,
        itemsPerPage: data?.meta?.itemsPerPage ?? data?.items?.length,
        onChangePage: (page) => onChangeFiltro({ page }),
      }}
    />
  );
}
